import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pt-[20px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = {
  class: "pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]",
  id: "offersNavigation"
}
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = {
  class: "pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px] text-center",
  id: "offersForm"
}
const _hoisted_6 = { class: "text-left text-2xl font-light mb-[2%]" }
const _hoisted_7 = {
  key: 0,
  class: "mt-6 mb-4 p-4 border border-gray-200 rounded bg-gray-50",
  "data-cy": "access-control-section"
}
const _hoisted_8 = { class: "text-left text-lg font-medium mb-3" }
const _hoisted_9 = { class: "text-left text-sm text-gray-600 mb-3" }
const _hoisted_10 = { class: "text-left text-sm text-gray-500" }

import { ref, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import offerNavigation from '@/components/SubNavigations/TheOfferNavigation.vue'
    import FormInput from '@/components/Offers/FormInput.vue'
    import FormSelect from '@/components/Offers/FormSelect.vue'
    import useOfferStore from '@/utils/useOfferStore'
    import { Canton, Details, SchoolType } from '@/constants/offers'
    import { SelectItem } from '@/model/types'
    import { ExtendedContract } from '@/model/types'
    import { useI18n } from 'vue-i18n'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OffersCreateOffer',
  setup(__props) {

    const route = useRoute()
    const formRef = ref(null)
    let isExistingOffer = ref(false)
    const { t } = useI18n()

    const {
        fetchContracts,
        updateOffer,
        createOffer,
        selectedOffer,
        contracts,
        signaturesList,
        offers,
        loading,
        fetchOfferAccess,
        updateOfferAccess,
        getHateoasLinks,
        hasLink,
        fetchThirdPartyPartners,
    } = useOfferStore()

    const localRoleAccess = ref<string[]>([])
    const hasOffersRole = ref(false)
    const thirdPartyPartners = ref<any[]>([])

    async function fetchDataOnMounted() {
        try {
            await fetchContracts()
            filterContracts()
            const links = await getHateoasLinks()
            hasOffersRole.value = hasLink('offer/access/update')

            // Only fetch third party partners if user has Offers role
            if (hasOffersRole.value) {
                thirdPartyPartners.value = await fetchThirdPartyPartners()

                // Load existing access if editing an offer
                if (isExistingOffer.value && selectedOffer.value?.id) {
                    try {
                        const accessData = await fetchOfferAccess(selectedOffer.value.id)
                        if (accessData && accessData.roles) {
                            localRoleAccess.value = accessData.roles.map((role: { role_id: any }) =>
                                String(role.role_id)
                            )
                        } else {
                            localRoleAccess.value = []
                        }
                    } catch (error) {
                        console.error('Error fetching offer access:', error)
                        localRoleAccess.value = []
                    }
                }
            }
        } catch (error) {
            console.error('Error initializing form data:', error)
        }
    }

    const localNumStudents = ref('')
    const localNumTeachers = ref('')
    const localNumUserCorrection = ref('')
    const localSelectedSchoolType = ref('')
    const localDetail = ref('')
    const localCanton = ref('')
    const localHasBeenSent = ref(false)
    const localComments = ref('')
    const localContract = ref({})
    const filteredContracts = ref<ExtendedContract[]>([])

    onMounted(() => {
        // Determine if this is an existing offer based on route
        const offerId = route.params.offerId || route.params.id?.toString().split('/').pop()
        isExistingOffer.value = !!(offerId && offerId !== '0' && selectedOffer.value?.id)

        // Initialize form values if editing existing offer
        if (isExistingOffer.value && selectedOffer.value) {
            localNumStudents.value = selectedOffer.value.numStudents || ''
            localNumTeachers.value = selectedOffer.value.numTeachers || ''
            localNumUserCorrection.value = selectedOffer.value.numUserCorrection || ''
            localSelectedSchoolType.value = selectedOffer.value.selectedSchoolType || ''
            localDetail.value = selectedOffer.value.detail || ''
            localCanton.value = selectedOffer.value.canton || ''
            localHasBeenSent.value = selectedOffer.value.hasBeenSent || false
            localComments.value = selectedOffer.value.comments || ''
            localContract.value = selectedOffer.value.contract || {}
        }

        fetchDataOnMounted()
    })

    const itemValue = (item: SelectItem) => item.key
    const itemText = (item: SelectItem) => item.value
    const itemTitle = (item: SelectItem) => item.value

    // Check route params to determine if this is a new or existing offer
    const offerId = route.params.offerId || route.params.id?.toString().split('/').pop()
    isExistingOffer.value = offerId && offerId !== '0' && selectedOffer.value?.id

    const rules = {
        required: (value: string) => !!value || t('offers.required'),
        requiredContract: (value: any) => {
            if (!value || typeof value !== 'object') return t('offers.required')
            return Object.keys(value).length > 0 || t('offers.required')
        },
        number: (value: string) => /^[\d]*$/.test(value) || t('offers.numberValidation'),
    }

    function filterContracts() {
        if (!contracts.value || !Array.isArray(contracts.value)) {
            console.error('Contracts data is not available')
            return
        }
        filteredContracts.value = contracts.value.filter((contract) => {
            return contract.Typ == localDetail.value && contract[localCanton.value] == '1'
        })
    }

    async function submit() {
        try {
            const isValid = formRef.value ? await (formRef.value as any).validate() : null
            if (isValid?.valid) {
                const offerData = {
                    numStudents: localNumStudents.value,
                    numTeachers: localNumTeachers.value,
                    numUserCorrection: localNumUserCorrection.value || 0,
                    schoolType: localSelectedSchoolType.value,
                    detail: localDetail.value,
                    canton: localCanton.value,
                    hasBeenSent: localHasBeenSent.value,
                    comments: localComments.value,
                    contract: localContract.value,
                }
                let offerId
                if (selectedOffer.value && selectedOffer.value.id) {
                    Object.assign(selectedOffer.value, offerData)
                    await updateOffer({
                        contactId: parseInt(route.params.id.toString()),
                        offerId: selectedOffer.value.id,
                        offer: selectedOffer.value,
                    })
                    offerId = selectedOffer.value.id
                } else {
                    const result = await createOffer({
                        contactId: parseInt(route.params.id.toString()),
                        offer: offerData,
                    })
                    offerId = result?.offer_id
                }

                // Update access control only if user has Offers role and we have a valid offer ID
                if (hasOffersRole.value && offerId) {
                    const roleIds = localRoleAccess.value
                        .filter((id) => id && id.trim() !== '')
                        .map((id) => parseInt(id))
                    await updateOfferAccess(offerId, roleIds)
                }
            }
        } catch (error) {
            console.error('Error during submission: ', error)
        }
    }

    function onChangeSchoolType() {
        localDetail.value = ''
        localCanton.value = ''
        filteredContracts.value = []
    }

    const breadcrumbs = [
        { title: 'Offerten', disabled: false, href: '/offers' },
        { title: 'Kontakt auswählen', disabled: false, href: '/offers/selectcontacts' },
        { title: 'Parameter eingeben', disabled: true, href: '/offers/createoffer/' },
    ]

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(offerNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_breadcrumbs, { items: breadcrumbs }),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('offers.createOfferTitle')), 1)
        ]),
        _createVNode(_component_v_form, {
          onSubmit: _withModifiers(submit, ["prevent"]),
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_container, { fluid: "" }, {
              default: _withCtx(() => [
                _createVNode(FormInput, {
                  id: "numStudents",
                  modelValue: localNumStudents.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localNumStudents).value = $event)),
                  rules: [rules.required, rules.number],
                  label: _ctx.$t('offers.numStudentsLabel'),
                  required: "",
                  onChange: _cache[1] || (_cache[1] = (e) => (localNumStudents.value = e.target.value)),
                  disabled: _unref(isExistingOffer)
                }, null, 8, ["modelValue", "rules", "label", "disabled"]),
                _createVNode(FormInput, {
                  id: "numTeachers",
                  modelValue: localNumTeachers.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localNumTeachers).value = $event)),
                  rules: [rules.required, rules.number],
                  label: _ctx.$t('offers.numTeachersLabel'),
                  required: "",
                  onChange: _cache[3] || (_cache[3] = (e) => (localNumTeachers.value = e.target.value)),
                  disabled: _unref(isExistingOffer)
                }, null, 8, ["modelValue", "rules", "label", "disabled"]),
                _createVNode(FormInput, {
                  id: "numUserCorrection",
                  modelValue: localNumUserCorrection.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localNumUserCorrection).value = $event)),
                  rules: [rules.number],
                  label: _ctx.$t('offers.userCorrectionLabel'),
                  onChange: _cache[5] || (_cache[5] = (e) => (localNumUserCorrection.value = e.target.value)),
                  disabled: _unref(isExistingOffer)
                }, null, 8, ["modelValue", "rules", "label", "disabled"]),
                _createVNode(FormSelect, {
                  id: "schoolType",
                  modelValue: localSelectedSchoolType.value,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event: any) => ((localSelectedSchoolType).value = $event)),
                    onChangeSchoolType
                  ],
                  items: _unref(SchoolType),
                  "item-value": itemValue,
                  "item-text": itemText,
                  "item-title": itemTitle,
                  rules: [rules.required],
                  label: _ctx.$t('offers.schoolTypeLabel'),
                  required: "",
                  disabled: _unref(isExistingOffer)
                }, null, 8, ["modelValue", "items", "rules", "label", "disabled"]),
                _createVNode(FormSelect, {
                  id: "detail",
                  modelValue: localDetail.value,
                  "onUpdate:modelValue": [
                    _cache[7] || (_cache[7] = ($event: any) => ((localDetail).value = $event)),
                    filterContracts
                  ],
                  items: localSelectedSchoolType.value ? _unref(Details)[localSelectedSchoolType.value] : [],
                  "item-value": itemValue,
                  "item-text": itemText,
                  "item-title": itemTitle,
                  rules: [rules.required],
                  label: _ctx.$t('offers.detailsLabel'),
                  required: "",
                  disabled: _unref(isExistingOffer)
                }, null, 8, ["modelValue", "items", "rules", "label", "disabled"]),
                _createVNode(FormSelect, {
                  id: "canton",
                  modelValue: localCanton.value,
                  "onUpdate:modelValue": [
                    _cache[8] || (_cache[8] = ($event: any) => ((localCanton).value = $event)),
                    filterContracts
                  ],
                  items: _unref(Canton),
                  "item-value": itemValue,
                  "item-text": itemText,
                  "item-title": itemTitle,
                  rules: [rules.required],
                  label: _ctx.$t('offers.cantonLabel'),
                  required: "",
                  disabled: _unref(isExistingOffer)
                }, null, 8, ["modelValue", "items", "rules", "label", "disabled"]),
                _createVNode(_component_v_textarea, {
                  id: "comments",
                  modelValue: localComments.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((localComments).value = $event)),
                  label: _ctx.$t('offers.commentsLabel')
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_v_radio_group, {
                  class: "w-fit",
                  modelValue: localContract.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((localContract).value = $event)),
                  row: "",
                  rules: _unref(isExistingOffer) ? [] : [rules.requiredContract],
                  disabled: _unref(isExistingOffer)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredContracts.value, (contract) => {
                      return (_openBlock(), _createBlock(_component_v_radio, {
                        id: contract?.UUID,
                        key: contract?.UUID,
                        label: String(contract?.LeadPortal_Name),
                        value: contract,
                        disabled: _unref(isExistingOffer)
                      }, null, 8, ["id", "label", "value", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "rules", "disabled"]),
                (hasOffersRole.value && thirdPartyPartners.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("h3", _hoisted_8, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('offers.accessControlTitle')), 1)
                      ]),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('offers.accessControlDescription')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(thirdPartyPartners.value, (partner) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: partner.role_id,
                          class: "mb-2"
                        }, [
                          _createVNode(_component_v_checkbox, {
                            modelValue: localRoleAccess.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((localRoleAccess).value = $event)),
                            value: partner.role_id.toString(),
                            label: `${partner.partner_name} (${partner.role_name})`,
                            color: "#db0720",
                            "hide-details": ""
                          }, null, 8, ["modelValue", "value", "label"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_checkbox, {
                  modelValue: localHasBeenSent.value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((localHasBeenSent).value = $event)),
                  color: "#db0720",
                  label: _ctx.$t('offers.shippedLabel')
                }, null, 8, ["modelValue", "label"]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('offers.note')), 1)
              ]),
              _: 1
            }),
            _createVNode(FullButton, {
              "data-cy": "submit",
              handleClick: submit,
              width: "100",
              title: _ctx.$t('offers.saveButton'),
              colour: "white"
            }, null, 8, ["title"])
          ]),
          _: 1
        }, 512)
      ])
    ])
  ], 64))
}
}

})